<form [formGroup]="registrationForm" (ngSubmit)="onRegistrationSubmit()" #regForm="ngForm">
  <div class="md_log register_mod" role="document" id="reg_scrl">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <h4 class="reg_main">Account Details</h4>
        </div>
        <div class="col-md-12 col-sm-6" #UserId>
          <div class="form-group">
            <label class="frm_use">Username</label>
            <input type="text" class="form-control" placeholder="Username" formControlName="UserId"
              (blur)="checkRepeatedUname()" #UserIdInput>

            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('UserId').hasError('required') && regForm.submitted">Username is
              required
            </div>
            <div style="color: red;" class="err-msg" *ngIf="repeatUserIdErr">Username is already taken. Please use
              another
              username
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" #Password>
          <div class="form-group">
            <label class="frm_use">Password</label>
            <input type="password" class="form-control" placeholder="Set Password"
              formControlName="Password" #PasswordInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('Password').hasError('required') && regForm.submitted">Password is
              required
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" #ConfirmPassword>
          <div class="form-group">
            <label class="frm_use">Confirm Password</label>
            <input type="password" class="form-control" placeholder="Confirm Password"
              formControlName="ConfirmPassword" #ConfirmPasswordInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('ConfirmPassword').hasError('required') && regForm.submitted">Confirm
              Password is required
            </div>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('ConfirmPassword').hasError('conformErrorMsg') && regForm.submitted && !registrationForm.get('ConfirmPassword').hasError('required')">
              Confirm Password Must Match Password custom
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-16">

        </div>
        <div class="col-md-12 col-sm-12">
          <h4 class="reg_main">Personal Details</h4>
        </div>
        <div class="col-md-6 col-sm-6" #FirstName>
          <div class="form-group">
            <label class="frm_use">Firstname</label>
            <input type="text" class="form-control" placeholder="Firstname"
              formControlName="FirstName" #FirstNameInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('FirstName').hasError('required') && regForm.submitted">FirstName is
              required
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" #LastName>
          <div class="form-group">
            <label class="frm_use">Lastname</label>
            <input type="text" class="form-control" placeholder="Lastname" formControlName="LastName"
              #LastNameInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('LastName').hasError('required') && regForm.submitted">LastName is required
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" #COMPANY>
          <div class="form-group">
            <label class="frm_use">Company Name</label>
            <input type="text" class="form-control" placeholder="Your Company Name"
              formControlName="COMPANY" #COMPANYInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('COMPANY').hasError('required') && regForm.submitted">Company Name is required
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" #EMailId>
          <div class="form-group">
            <label class="frm_use">Primary Email Id</label>
            <input type="email" class="form-control" placeholder="Your Email" formControlName="EMailId"
              #EMailIdInput>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('EMailId').hasError('required') && regForm.submitted">Email is required</div>
            <div style="color: red;" class="err-msg"
              *ngIf="registrationForm.get('EMailId').hasError('email') && regForm.submitted">Email is not valid </div>

          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <label class="frm_use">Telephone</label>
          <div class="row"  style="display: flex;">
            <div class="col-lg-3 col-md-3 col-sm-3 col-3">
              <input type="text" class="form-control" formControlName="PCCode">
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-9 pl-0">
              <input type="text" class="form-control" formControlName="Phone">
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12" #MobileNo>
          <label class="frm_use">Mobile Number</label>
          <div class="row"  style="display: flex;">
            <div class="col-lg-3 col-md-3 col-sm-3 col-3">
              <input type="text" class="form-control" formControlName="MobCode">
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-9 pl-0">
              <input type="text" class="form-control" formControlName="MobileNo" #MobileNoInput>
            </div>
          </div>
          <div style="color: red;" class="err-msg"
            *ngIf="registrationForm.get('MobileNo').hasError('required') && regForm.submitted">Mobile No.
            is required
          </div>
        </div>

        <div class="col-md-12 col-sm-12 chk_term">
          <label class="frm_use" (click)="OpenTermsConPop()" style="color: #007bff;"><a
              class="cret">Terms and Conditions</a></label>
          <mat-checkbox class="mb_regs" [checked]="termsAggred" (change)="termsAggred=!termsAggred;">
            <span class="frm_txt">I have read and agree to the terms and conditions</span>
          </mat-checkbox>
          <span style="color: red;" class="err-msg term-eror" *ngIf="!termsAggred && regForm.submitted">Please accept
            the terms.<br></span>
        </div>
        <div class="col-md-12 col-sm-12 chk_term">
          <button type="submit" class="btn btn_login">Register</button>
        </div>
      </div>
    </div>
  </div>
</form>

<div id="cover" [@ShowHide]="loaderspinning ? 'spinning' : 'stopped'">
  <img src="https://pcknstg.blob.core.windows.net/hdfile/webimg/logo_spin.png" class="img_spin">
</div>
